
import { defineComponent, PropType } from "vue";
import { createInstance } from '@/helpers/axios';
import { InputSizeEnum } from "@/models/enum/InputSizeEnum";

export default defineComponent({
  name: "InputSelect",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: String,
    },
    label: {
      type: String,
    },
    name: {
      type: String,
    },
    errors: {
      type: Object,
    },
    rules: {
      type: [String, Object] as PropType<string | Record<string, unknown | unknown[]>>,
      default: ''
    },
    disabled: {
      type: Boolean,
    },
    placeholder: {
      type: String,
    },
    selectText: {
      type: String,
    },
    help: {
      type: String,
      required: false,
      default: null,
    },
    isFloating: {
      type: Boolean,
      required: false,
      default: true,
    },
    inputSize: {
      type: String,
      required: false,
      default: InputSizeEnum.SM,
    },
    options: {
      type: Array,
      required: false,
      default: null,
      validator(options: any) {
        return options.every((o: any) => 'code' in o && 'description' in o);
      },
    },
    optionsMap: {
      type: Map,
      required: false,
      default: null,
    },
    url: {
      type: String,
      required: false,
      default: null,
    },
    canClear: {
      type: Boolean,
      required: false,
      default: false
    },
    validateOnInput: {
      type: Boolean,
      required: false,
      default: true
    },
    validateOnChange: {
      type: Boolean,
      required: false,
      default: true
    },
    validateOnBlur: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
    enums: {
      inputSizeEnum: InputSizeEnum,
    },
    fetchedOptions: [],
  }),
  computed: {
    selectOptions() {
      return this.url ? this.fetchedOptions : (this.options ?? this.optionsMap);
    },
  },
  methods: {
    updateValue(value: any) {
      this.$emit('update:modelValue', value);
    },
    validateField() {
      // This function is called from OUTSIDE the component
      return (this.$refs.internalField as any)?.validate?.();
    }
  },
  async mounted() {
    if (this.url) {
      const axios = createInstance();
      const response = await axios.get(this.url);
      this.fetchedOptions = response.data;
    }
  },
});
